import { useSnackbar } from "notistack";
import React, { SetStateAction } from "react";
import { useNavigate } from "react-router-dom";
import { IAvailabilitySlot } from "../MeetingPollDetailPage";
import { useSelector } from "react-redux";
import { RootState } from "@store/reducers";
import { checkIsSlotDisabled } from "../helpers/slotHelpers";

interface MeetingActionButtonContainerProps {
  interviewId: string;
  slot: IAvailabilitySlot;
  selectedAvailabiliy: string;
  setSelectedAvailabiliy: React.Dispatch<SetStateAction<string>>;
  availabilitySlots: IAvailabilitySlot[];
  setAvailabilitySlots: React.Dispatch<SetStateAction<IAvailabilitySlot[]>>;
  disableActionContainer: boolean;
  isInviteSend: boolean;
  isSlotDisabled: boolean;
  isFinalInviteSlot: boolean;
}

const MeetingActionButtonContainer = (
  props: MeetingActionButtonContainerProps
) => {
  const {
    interviewId,
    slot,
    isInviteSend,
    selectedAvailabiliy,
    setSelectedAvailabiliy,
    availabilitySlots,
    setAvailabilitySlots,
    disableActionContainer,
    isSlotDisabled,
    isFinalInviteSlot,
  } = props;
  const navigate = useNavigate();
  const user: any = useSelector((state: RootState) => state.auth.user);
  const { enqueueSnackbar } = useSnackbar();

  const isAcceptedTemp = slot?.isAcceptedTemp;
  const isDeclinedTemp = slot?.isDeclinedTemp;

  // const showSendInvite =
  //   slot?.isCandidateAvailable &&
  //   slot?.isCompanyAvailable &&
  //   isAccepted &&
  //   user?.userType === EnumUserTypes.RECRUITER;

  const handleAcceptOrDecline = async ({
    type,
  }: {
    type: "accept" | "decline";
  }) => {
    if (type === "accept") {
      if (isFinalInviteSlot) {
        setAvailabilitySlots((prev) => {
          return prev?.map((prevSlot, index) => {
            if (prevSlot?._id === selectedAvailabiliy) {
              // console.log("index selected", index, prevSlot);
              return {
                ...prevSlot,
                isDeclinedTemp: true,
                isAcceptedTemp: false,
              };
            } else if (prevSlot?._id === slot._id) {
              // console.log("index equal id", index, prevSlot);
              return {
                ...prevSlot,
                isDeclinedTemp: false,
                isAcceptedTemp: true,
              };
            } else if (!checkIsSlotDisabled(prevSlot)) {
              // console.log("index slot disabled not", index, prevSlot);
              return {
                ...prevSlot,
                isDeclinedTemp: true,
                isAcceptedTemp: false,
              };
            } else {
              // console.log("index", index, prevSlot);
              return prevSlot;
            }
          });
        });
        setSelectedAvailabiliy(slot?._id);
      } else {
        setAvailabilitySlots((prev) => {
          return prev?.map((prevSlot) => {
            return prevSlot?._id === slot?._id
              ? { ...prevSlot, isDeclinedTemp: false, isAcceptedTemp: true }
              : prevSlot;
          });
        });
      }
    } else {
      if (slot?._id === selectedAvailabiliy) {
        setSelectedAvailabiliy("");
      }
      setAvailabilitySlots((prev) => {
        return prev?.map((prevSlot) => {
          return prevSlot?._id === slot?._id
            ? { ...prevSlot, isDeclinedTemp: true, isAcceptedTemp: false }
            : prevSlot;
        });
      });
    }
  };

  return (
    <div className="flex items-center gap-2">
      {/* {disableActionContainer?.toString()}{isSlotDisabled?.toString()} */}
      <button
        disabled={isAcceptedTemp || disableActionContainer || isSlotDisabled}
        onClick={() => handleAcceptOrDecline({ type: "accept" })}
        className={`flex items-center justify-center ${
          isAcceptedTemp
            ? "bg-primary text-white"
            : `bg-white border ${
                !disableActionContainer && !isSlotDisabled
                  ? "hover:bg-gray-100"
                  : "opacity-50 cursor-not-allowed"
              }`
        } text-xs font-semibold rounded-md py-1.5 w-full gap-3`}
      >
        {isAcceptedTemp ? "Accepted" : "Accept"}
      </button>
      <button
        disabled={isDeclinedTemp || disableActionContainer || isSlotDisabled}
        onClick={() => handleAcceptOrDecline({ type: "decline" })}
        className={`flex items-center justify-center gap-4  ${
          isDeclinedTemp
            ? "bg-red-600 text-white"
            : `bg-white border ${
                !disableActionContainer && !isSlotDisabled
                  ? "hover:bg-gray-100"
                  : "opacity-50 cursor-not-allowed"
              } text-primary`
        } border  text-xs font-semibold rounded-md py-1.5 w-full `}
      >
        {isDeclinedTemp ? "Declined" : "Decline"}
      </button>
    </div>
  );
};

export default MeetingActionButtonContainer;
